import Image from "next/image";
import Button from "@components/atoms/Button";
import Text from "@components/atoms/Text";
import { RecentSearchesProps } from "@interfaces/search-component.types";
import assetLoader from "@utils/internalImageLoder";
import styles from "../../organisms/SearchComponent/SearchComponent.module.scss";

export const RecentSearches = ({
  recentSearches,
  onRecentSearchClick,
  searchQuery,
  variant,
}: RecentSearchesProps) => {
  if (recentSearches.length === 0 || searchQuery.trim()) {
    return null;
  }

  return (
    <div className={styles.recentSearchContainer}>
      <Text className={styles.recentSearchTitle}>Your recent searches</Text>
      <div className={styles.recentSearchTags}>
        {recentSearches?.map((search, index) => (
          <Button
            key={index}
            className={styles.recentSearchTag}
            onClick={() => onRecentSearchClick(search.query, search.type)}
          >
            <Image
              src={`${assetLoader()}/icons/search.svg`}
              alt="Search"
              width={16}
              height={16}
              className={styles.recentSearchIcon}
              loading="lazy"
            />
            {search.query}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default RecentSearches;
